import React from 'react';
import { Animated, ImageBackground, View } from 'react-native';

export default class GraphicBackground extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      opacityAnimate: new Animated.Value(0),
    }
  }

  componentDidMount() {
    if (!!(this.props.fadeIn)) {
      this.animateIn();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isFadingOutBackground === false && this.props.isFadingOutBackground === true) {
      this.animateOut();
    }
  }

  animateIn = () => {
    let { opacityAnimate } = this.state;
    opacityAnimate.setValue(0);
    Animated.timing(opacityAnimate, { toValue: 1, duration: 1500, useNativeDriver: false }).start();
  }

  animateOut = () => {
    let { opacityAnimate } = this.state;
    opacityAnimate.setValue(1);
    Animated.timing(opacityAnimate, { toValue: 0, duration: 750, useNativeDriver: false }).start();
  }

  // Image map for dynamic loading
  static imageMap = {
    'BusDepotDoor.jpg': require('../../assets/images/backgrounds/BusDepotDoor.jpg'),
    'BusFleet.jpg': require('../../assets/images/backgrounds/BusFleet.jpg'),
    'CrazyGolf.jpg': require('../../assets/images/backgrounds/CrazyGolf.jpg'),
    'LidoPromenade.jpg': require('../../assets/images/backgrounds/LidoPromenade.jpg'),
    'MapBayOfMorecambe.jpg': require('../../assets/images/backgrounds/MapBayOfMorecambe.jpg'),
    'MapMorecambe.jpg': require('../../assets/images/backgrounds/MapMorecambe.jpg'),
    'MapRailway.jpg': require('../../assets/images/backgrounds/MapRailway.jpg'),
    'WestEnd20s.jpg': require('../../assets/images/backgrounds/WestEnd20s.jpg'),
    'WestEndFountains.jpg': require('../../assets/images/backgrounds/WestEndFountains.jpg'),
    'WestEndGardens.jpg': require('../../assets/images/backgrounds/WestEndGardens.jpg'),    
  };

  _imageResource() {
    const defaultImage = require("../../assets/images/clouds.jpg");
    return GraphicBackground.imageMap[this.props.source] || defaultImage;
  }

  render() {

    if (!!(this.props.fadeIn)) {
      return (
        <View style={{ backgroundColor: "black", flex: 1 }}>
          <Animated.View style={{ flex: 1, width: '100%', height: '100%', opacity: this.state.opacityAnimate }}>
            <ImageBackground source={this._imageResource()} style={{ width: '100%', height: '100%', flex: 1 }}>
              {this.props.children}
            </ImageBackground>
          </Animated.View>
        </View>
      )

    } else {
      return (
        <View style={{ backgroundColor: "black", flex: 1 }}>
          <ImageBackground source={this._imageResource()} style={{ width: '100%', height: '100%', flex: 1 }}>
            {this.props.children}
          </ImageBackground>
        </View>
      )
    }

  }
}

